import script from "./RegisterModalByLink.vue?vue&type=script&lang=ts&setup=true"
export * from "./RegisterModalByLink.vue?vue&type=script&lang=ts&setup=true"

import "./RegisterModalByLink.vue?vue&type=style&index=0&id=879dd9b0&scoped=true&lang=css"
/* custom blocks */
import block0 from "./RegisterModalByLink.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-879dd9b0"]])

export default __exports__